export { default } from "ember-focus-trap/modifiers/focus-trap.js";
